module.exports = __webpack_public_path__ + "static/media/imgplaceholder.50c42ef7.jpg";